import { User } from 'models/user';

export type OrderEvent = {
    id: string;
    date: number;
    type: OrderEventType;
    orderId: string;
    orderDbId: string;
    user?: User;
    color: OrderEventColor;
    message?: string;
    lineItems?: string[];
    files?: File[];
    manualSelectedDate: Date;
    version?: number;
};

export type File = {
    _id: string;
    filename: string;
    mimetype: string;
    url: string;
};

export type OrderEventFilters = {
    comments: boolean;
    chat: boolean;
    files: boolean;
    modified: boolean;
    status: boolean;
};

export type EventOrgTypeFilter = {
    showClinicEvents: boolean;
    showLabEvents: boolean;
};

export enum OrderEventType {
    ORDER_CREATED = 'ORDER_CREATED',
    ORDER_MODIFIED = 'ORDER_MODIFIED',
    ORDER_RESEND = 'ORDER_RESEND',
    STATUS_CHANGE = 'STATUS_CHANGE',
    NEW_COMMENT = 'NEW_COMMENT',
    NEW_CHAT_MESSAGE = 'NEW_CHAT_MESSAGE',
    FILES_ADDED = 'FILES_ADDED',
}

export type OrderEventColor = 'colorOne' | 'colorTwo' | 'colorThree';
